<template>
  <div class="work">
    <section-heading>How does the Colloquium work with You?</section-heading>
    <div class='work__wrapper'>
      <tabs mode="two">
        <tab title="Business Owners/Entrepreneurs">
          <div class="tab__title">
            <p>During the three months of the Colloquium, you work on 4 live Games or Projects:</p>
          </div>
          <div class="tab__content">
            <b-container>
              <ul class="tab__wrapper">
                <li class="tab__item">
                  <h5 class="tab__number">1</h5>
                  <img src="../../assets/image/about/circle1-1.png" alt="">
                  <h6 class="tab__name">BUSINESS OR <br> PROFESSIONAL</h6>
                </li>
                <li class="tab__item">
                  <h5 class="tab__number">2</h5>
                  <img src="../../assets/image/about/circle1-2.png" alt="">
                  <h6 class="tab__name">FAMILY</h6>
                </li>
                <li class="tab__item">
                  <h5 class="tab__number">3</h5>
                  <img src="../../assets/image/about/circle1-3.png" alt="">
                  <h6 class="tab__name">DREAM</h6>
                </li>
                <li class="tab__item">
                  <h5 class="tab__number">4</h5>
                  <img src="../../assets/image/about/circle1-4.png" alt="">
                  <h6 class="tab__name">HAVE TO DO <br> (WHAT YOU ARE  AVOIDING)</h6>
                </li>
              </ul>
            </b-container>  
          </div>
        </tab>
        <tab title="Corporate">
          <div class="tab__title">
            <p>During the three months of the Colloquium, you work on 4 live Games or Projects:</p>
          </div>
          <div class="tab__content">
            <b-container>
              <ul class="tab__wrapper">
                <li class="tab__item">
                  <h5 class="tab__number">2.1</h5>
                  <img src="../../assets/image/about/circle1-1.png" alt="">
                  <h6 class="tab__name">BUSINESS OR <br> PROFESSIONAL</h6>
                </li>
                <li class="tab__item">
                  <h5 class="tab__number">2.2</h5>
                  <img src="../../assets/image/about/circle1-2.png" alt="">
                  <h6 class="tab__name">FAMILY</h6>
                </li>
                <li class="tab__item">
                  <h5 class="tab__number">2.3</h5>
                  <img src="../../assets/image/about/circle1-3.png" alt="">
                  <h6 class="tab__name">DREAM</h6>
                </li>
                <li class="tab__item">
                  <h5 class="tab__number">2.4</h5>
                  <img src="../../assets/image/about/circle1-4.png" alt="">
                  <h6 class="tab__name">HAVE TO DO <br> (WHAT YOU ARE  AVOIDING)</h6>
                </li>
              </ul>
            </b-container>
          </div>
        </tab>
      </tabs>
    </div>
  </div>

</template>
<script>
import Heading from '../Shared/Heading';
import Tab from './AB-Tab.vue'
import Tabs from './AB-Tabs.vue'
export default {
  components:{
    'section-heading':Heading,
    Tab,
    Tabs
  }
}
</script>
<style scoped>
.work__wrapper{
  margin: 24px 0 52px 0;
}

.tab__title{
  margin-top:50px;
  text-align: center;
}

.tab__title p{
  font-family: "Seravek-Medium";
  text-align: center;
  font-size: 24px;
  line-height: 30px;
  color: var(--text-color);
  margin-bottom: 0;
}

.tab__content{
  background: url('../../assets/image/about/work.jpg');
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
  text-align: center;
  padding: 50px 0;
}



.tab__wrapper{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 360px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.tab__item img{
  margin:20px 0;
}

.tab__number{
  font-size: 48px;
  font-family: "Seravek-Bold";
  color: #6d6e71;
}

.tab__name{
  font-size: 20px;
  font-family: "Seravek-Medium";
  color: var(--text-color);
  text-transform: uppercase;
}

.tab__item:nth-child(even) { 
  align-self: flex-end;
}

.tab__item:nth-child(odd) { 
  align-self: flex-start;
}

/* Mobiles (Portrait) */
@media (min-width: 320px) and (max-width: 480px) {
  .tab__title p{
    font-size: 20px;
    line-height: 24px;
  }

  .tab__content{
    padding: 25px 0;
  }
  
  .tab__wrapper{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .tab__item:nth-child(odd),.tab__item:nth-child(even){
    align-self: center;
    margin-bottom: 20px;
  }

  .tab__number{
    font-size: 24px;
  }

  .tab__item img {
    margin: 5px 0;
  }

  .tab__name{
    font-size: 19px;
  }

  .work__wrapper{
    margin: 20px 0 25px 0;
  }
}
/* Low Resolution Tablets, Mobiles (Landscape) */
@media (min-width: 481px) and (max-width: 767px) {
  .tab__title p{
    font-size: 20px;
    line-height: 24px;
  }

  .tab__content{
    padding: 25px 0;
  }
  
  .tab__wrapper{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .tab__item:nth-child(odd),.tab__item:nth-child(even){
    align-self: center;
    margin-bottom: 20px;
  }

  .tab__number{
    font-size: 24px;
  }

  .tab__item img {
    margin: 5px 0;
  }

  .tab__name{
    font-size: 19px;
  }

  .work__wrapper{
    margin: 20px 0 25px 0;
  }
}

</style>